// extracted by mini-css-extract-plugin
module.exports = {"box":"contact_box__2XkOK","container":"contact_container__1d7HZ"};